var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { MenuItem } from './menu-item';
import { useLang } from '../hooks/use-lang';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
import { LightGlobeOffIconGlyph, LightGlobeOnIconGlyph, LightGlobeSystemDarkIconGlyph, LightGlobeSystemLightIconGlyph } from '@shapeable/icons';
import { SiteMenuTitle } from '../entities/site-menu-title';
var cls = classNames('lang-menu');
export var ThemeModeMenuDefaultProps = {
  showTitle: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var CircleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border-radius: 32px;\n    height: 0;\n    width: 0;\n    border: 4px solid ", ";\n    font-size: 0;\n    width: 24px;\n    height: 24px;\n  "], ["\n    border-radius: 32px;\n    height: 0;\n    width: 0;\n    border: 4px solid ", ";\n    font-size: 0;\n    width: 24px;\n    height: 24px;\n  "])), theme.COLOR('strong'))
});
var LightModeIconStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    background-color: ", ";\n  "], ["\n    ", ";\n    background-color: ", ";\n  "])), CircleStyles, theme.COLOR('light'))
});
var DarkModeIconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    background-color: ", ";\n  "], ["\n    ", ";\n    background-color: ", ";\n  "])), CircleStyles, theme.COLOR('dark'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(MenuItem)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  LightModeIcon: styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LightModeIconStyles),
  DarkModeIcon: styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), DarkModeIconStyles)
};
/* @ts-ignore */
export var ThemeModeMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
    showTitle = props.showTitle,
    onItemClick = props.onItemClick;
  var _a = useActiveThemeMode(),
    themeMode = _a.themeMode,
    isDark = _a.isDark,
    isSystemDark = _a.isSystemDark,
    setThemeMode = _a.setThemeMode;
  var t = useLang();
  var handleLightClick = function (e) {
    if (onItemClick) {
      onItemClick(e);
    }
    setThemeMode('light');
  };
  var handleDarkClick = function (e) {
    if (onItemClick) {
      onItemClick(e);
    }
    setThemeMode('dark');
  };
  var handleSystemClick = function (e) {
    if (onItemClick) {
      onItemClick(e);
    }
    setThemeMode('system');
  };
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, showTitle && React.createElement(SiteMenuTitle, null, t('Website Theme')), React.createElement(My.Item, {
    isActive: themeMode === 'light',
    onClick: handleLightClick,
    iconComponent: LightGlobeOnIconGlyph,
    label: t('Light Mode')
  }), React.createElement(My.Item, {
    isActive: themeMode === 'dark',
    onClick: handleDarkClick,
    iconComponent: LightGlobeOffIconGlyph,
    label: t('Dark Mode')
  }), React.createElement(My.Item, {
    isActive: themeMode === 'system',
    onClick: handleSystemClick,
    iconComponent: isSystemDark ? LightGlobeSystemDarkIconGlyph : LightGlobeSystemLightIconGlyph,
    label: t("Match System".concat(isSystemDark ? ': Dark' : ': Light'))
  }));
});
ThemeModeMenu.cls = cls;
ThemeModeMenu.defaultProps = ThemeModeMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;